import * as actions from './tdlrActions';

const initialState = {
  selected: '',
  appProfile: '',
};

const tdlrReducers = {
  [actions.TDLR_TDLRLR_CLEAR_DATA]: () => initialState,
  [actions.TDLR_RENEW_LICENSE]: (state, { payload }) => {
    return { ...state, ...{ selected: payload } };
  },
  [actions.TDLR_STORE_APP_PROFILE]: (state, { payload }) => {
    return { ...state, ...{ appProfile: payload } };
  },

  [actions.TDLR_UPDATE_PAYMENT_WAS_MADE]: (state, { status }) => {
    return {
      ...state,
      ...{
        appProfile: {
          ...state.appProfile,
          ...{ paymentWasMade: status },
        },
      },
    };
  },
};

export default {
  name: 'tdlr',
  reducers: tdlrReducers,
};
